/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

/**
 * Mobile cart safety net.
 * The theme's product form asks Shopify for HTML and then parses the response
 * as JSON. On some mobile browsers this prevents the add-to-cart flow from
 * completing. This handler uses Shopify's JSON cart endpoint directly and
 * keeps all native form fields, including quantity and selling plan.
 */
(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let submittingForm = null;

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (
        !mobileQuery.matches ||
        !(form instanceof HTMLFormElement) ||
        !form.matches('form[data-type="add-to-cart-form"]')
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (submittingForm === form) return;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const submitButton = form.querySelector('button[name="add"]');
      const formData = new FormData(form);
      const root = window.Shopify?.routes?.root || '/';
      let responseReceived = false;

      formData.delete('sections');
      formData.delete('sections_url');

      if (!formData.get('quantity')) {
        formData.set('quantity', '1');
      }

      submittingForm = form;
      if (submitButton instanceof HTMLButtonElement) submitButton.disabled = true;

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
          credentials: 'same-origin',
        });

        responseReceived = true;
        const result = await response.json().catch(() => ({}));

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Impossible d’ajouter cette box au panier.');
        }

        window.location.assign(`${root}cart`);
      } catch (error) {
        if (!responseReceived) {
          HTMLFormElement.prototype.submit.call(form);
          return;
        }

        const message = error instanceof Error ? error.message : 'Impossible d’ajouter cette box au panier.';
        window.alert(message);
      } finally {
        submittingForm = null;
        if (submitButton instanceof HTMLButtonElement) submitButton.disabled = false;
      }
    },
    true
  );
})();
